import { createFileRoute } from "@tanstack/react-router";
import AdminCurriculumNewPage from "@/pages/admin/lms/curricula/new";
import { useLmsPermissions } from "@/pages/admin/lms";

export const Route = createFileRoute("/app/admin/lms/curricula/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllMaterials, userCanViewAllMaterials } = useLmsPermissions();

  return (
    <AdminCurriculumNewPage
      userCanEditAllMaterials={userCanEditAllMaterials}
      userCanViewAllMaterials={userCanViewAllMaterials}
    />
  );
}
